import React from 'react';
import { Link } from 'gatsby';
import { AnimatePresence, motion } from 'framer-motion';

import { useScrollFreeze } from '@hooks/useScrollFreeze';
import { usePortalQuery } from '@querys/usePortalQuery';

import Exit from '@svg/exit.svg';
import Search from '@svg/search.svg';
import SearchWhite from '@svg/search-white.svg';

export const SearchModal = ({ setSearchOpen, searchOpen }) => {
  useScrollFreeze();

  const [value, setValue] = React.useState('');
  const linkRef = React.useRef(null);

  function onSubmit() {
    linkRef.current.click();
    setSearchOpen(false);
  }

  const { search } = usePortalQuery();

  //listen for <enter> key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  //run handleKeyPress on key press
  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyPress, { passive: true });
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <motion.div
      key={searchOpen}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='bg-teal xl:bg-sand fixed top-0 left-0 min-h-screen w-full z-40 xl:z-[100] flex flex-col items-center justify-center'>
      <div className='w-full absolute top-0 flex justify-end py-gutter lg:py-14 px-gutter lg:px-10'>
        <button
          onClick={() => setSearchOpen(false)}
          className='rounded-full w-16 h-16 bg-teal bg-opacity-10 hover:bg-opacity-100 nav-hover transition-standard'>
          <Exit className='p-5 w-full h-full' />
        </button>
      </div>
      <div className='grid grid-cols-14 w-full'>
        <div className='relative border-b border-white xl:border-teal flex items-center justify-between mt-8 md:mt-0 col-start-2 col-end-14 lg:col-start-3 lg:col-end-13'>
          <input
            type='text'
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder='Search'
            className='text-white xl:text-teal blockH4 focus:outline-none bg-teal xl:bg-sand border-0 focus:shadow-none form-input focus:ring-0 p-0 pb-3 xl:pb-6 placeholder:text-white xl:placeholder:text-teal placeholder:blockH4 w-full'
          />
          <div onClick={() => onSubmit()}>
            <SearchWhite className='xl:hidden w-6 h-6 cursor-pointer mb-3' />
            <Search className='hidden xl:block w-10 h-10 cursor-pointer mb-6' />
          </div>
        </div>
      </div>
      <Link
        ref={linkRef}
        to={`/${search?.slug?.current}`}
        className='hidden'
        state={{ value: value }}
      />
    </motion.div>
  );
};
